import React from 'react';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { IntegrationSettings } from '../types/integration_settings';
import { v4 } from 'uuid';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IntegrationContext, IntegrationSettingsContextProps } from '../context/IntegrationContext';

const integrationSettingsState = {
  items: new Map<string, IntegrationSettings>(),
  loading: false,
};

export const integrationSettingsSlice = createSlice({
  name: 'integrationSettings',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      integrationSettingsState.items = new Map();
      integrationSettingsState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<IntegrationSettings[]>) => {
      integrationSettingsState.items = new Map();
      action.payload.forEach(p => integrationSettingsState.items.set(p.id, new IntegrationSettings(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<IntegrationSettings[]>) => {
      action.payload.forEach(p => integrationSettingsState.items.set(p.id, new IntegrationSettings(p)));
      integrationSettingsState.items = new Map(integrationSettingsState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<IntegrationSettings[]>) => {
      action.payload.forEach(p => integrationSettingsState.items.delete(p.id));
      integrationSettingsState.items = new Map(integrationSettingsState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      integrationSettingsState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface IntegrationSettingsProviderProps {
  children: React.ReactNode;
}

export default function IntegrationSettingsProvider({ children }: IntegrationSettingsProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.integrationSettings.key);

  const pmdContext: IntegrationSettingsContextProps = {
    integrationSettings: integrationSettingsState.items,
    integrationSettingsLoading: integrationSettingsState.loading,
    setIntegrationSettings: (pmd: Map<string, IntegrationSettings>) => {
      dispatch(integrationSettingsSlice.actions.set([...pmd.values()]));
    },
  };

  return <IntegrationContext.Provider value={pmdContext}>{children}</IntegrationContext.Provider>;
}
